import { useSelector } from "react-redux";
import { selectAuthInfo } from "../pages/Auth/authSelectors";
import { isAdminUser } from "../utils/accessChecker";
import { hasWorkflowAccess } from "./workflowAccess";


const accessList = {
  dashboard: [{ label: "Dashboard", value: "dashboard" }],
  workflows: [{ label: "Workflows", value: "workflows" }],
  sales: [
    { label: "Sales Entry", value: "new_sales" },
    { label: "Customers", value: "customer_entry" },
    { label: "Sales Return Entry", value: "sales_return" },
    { label: "Product Replace", value: "product_replace" },
    { label: "View Sales Vouchers", value: "sales_voucher" },
    { label: "View Sales Return Vouchers", value: "sales_return_voucher" },
    { label: "Sales Record", value: "sales_record" },
    { label: "Sales Return Record", value: "sales_return_record" },
    { label: "Replace Record", value: "product_replace_record" },
  ],
  pos: [{ label: "POS", value: "pos_entry" }],
  quotation: [
    { label: "Quotation", value: "quotation_entry" },
    { label: "Quotation Record", value: "quotation_record" },
  ],
  order: [
    { label: "Sales Order Entry", value: "sales_order_entry" },
    { label: "Purchase Order Entry", value: "purchase_order_entry" },
    { label: "Sales Order Vouchers", value: "sales_order_voucher" },
    { label: "Purchase Order Vouchers", value: "purchase_order_voucher" },
    { label: "Purchase Order Record", value: "purchase_order_record" },
    { label: "Sales Order Record", value: "sales_order_record" },
  ],
  service: [
    { label: "Service Entry", value: "service_entry" },
    { label: "Service Expenses", value: "service_expense_entry" },
    { label: "View Service Vouchers", value: "service_voucher" },
    {
      label: "View Service Expense Vouchers",
      value: "service_expense_voucher",
    },
    { label: "Service Record", value: "service_record" },
    { label: "Service Expense Record", value: "service_expense_record" },
    { label: "Service Return Entry", value: "service_return" },
    { label: "Service Return Record", value: "service_return_record" },
    { label: "View Service Return Vouchers", value: "service_return_voucher" },
  ],
  purchase: [
    { label: "Purchase Entry", value: "purchase_entry" },
    { label: "Supplier Entry", value: "supplier_entry" },
    { label: "Purchase Return Entry", value: "purchase_return" },
    { label: "View Purchase Vouchers", value: "purchase_voucher" },
    {
      label: "View Purchase Return Vouchers",
      value: "purchase_return_voucher",
    },
    { label: "Purchase Record", value: "purchase_record" },
    { label: "Purchase Return Record", value: "purchase_return_record" },
  ],
  manufacturing: [
    { label: "Manufacturing Journal Entry", value: "production_entry" },
    { label: "Manufacturing Journal Vouchers", value: "production_voucher" },
    { label: "Manufacturing Journal Record", value: "production_record" },
  ],
  inventory: [
    { label: "Item Stock Report", value: "item_stock_report" },
    { label: "Item Ledger", value: "item_ledger" },
    { label: "Transfer", value: "transfer_entry" },
    { label: "Item Adjustment", value: "item_adjustment_entry" },
    { label: "Adjustment Record", value: "adjustment_record" },
    { label: "Transfer Record", value: "transfer_record" },
    { label: "Transfer Pending Record", value: "transfer_pending_record" },
    { label: "Transfer Receive Record", value: "transfer_receive_record" },
    { label: "Products", value: "item_entry" },
    { label: "Unit Entry & Measurement", value: "item_unit" },
    { label: "Group", value: "group_entry" },
    { label: "Categories", value: "item_category" },
    { label: "Models", value: "model_manage" },
    { label: "Origins", value: "origin_manage" },
    { label: "Generic Names", value: "generic_name" },
  ],
  accounts: [
    { label: "Customer Receipts", value: "debtor_receipt" },
    { label: "Supplier Payment", value: "creditor_payment" },
    { label: "Expense Entry", value: "expense_entry" },
    { label: "Expense Recognitions", value: "expense_recognition_entry" },
    {
      label: "Approve Expense Recognition",
      value: "approve_expense_recognition",
    },
    { label: "Income", value: "income_entry" },
    { label: "Contra/ Single", value: "contra_entry" },
    { label: "Advance Transactions", value: "advance_transaction_entry" },
    { label: "Journal/ Double", value: "journal_entry" },
    { label: "Branch Transactions", value: "branch_tran" },
    { label: "Accounts", value: "account_entry" },
    { label: "Locations", value: "location_entry" },
    { label: "Bank Transactions", value: "bank_transactions" },
    { label: "Cheques", value: "cheque_entry" },
  ],
  hrpayroll: [
    { label: "Salary Payments", value: "salary_payment" },
    { label: "Attendance", value: "attendance_entry" },
    { label: "Attendance Overview", value: "attendance_overview" },
    { label: "Approve Attendance", value: "approve_attendance" },
    { label: "Clients", value: "clients_entry" },
    { label: "Employees", value: "employee_entry" },
    { label: "Onboarding", value: "onboarding" },
    { label: "Work Routes", value: "work_routes" },
    { label: "Department Entry", value: "department_entry" },
    { label: "Designation", value: "designation_entry" },
    { label: "Location", value: "hrlocation" },
    { label: "Salary Payment Report", value: "salary_report" },
    { label: "Monthly salary Report", value: "monthly_salary_report" },
    { label: "HR settings View", value: "hr_settings_view" },
  ],
  reports: [
    { label: "Customer Due Balance", value: "debtor_balance" },
    { label: "Ageing Report", value: "ageing_report" },
    {
      label: "Customer Due Balance Invoice Wise",
      value: "debtor_balance_invoice_report",
    },
    { label: "Supplier Due Balance", value: "creditor_balance" },
    { label: "Customer Ledger", value: "debtor_ledger" },
    { label: "Supplier Ledger", value: "creditor_ledger" },
    { label: "Sales & Previous Collection Record", value: "collection_record" },
    { label: "Customer Receipt Record", value: "debtor_receipt_record" },
    { label: "Cash & Bank Accounts Balance", value: "cash_bank_balance" },
    { label: "Cash & Bank Account Ledger", value: "cash_bank_ledger" },
    { label: "Expense Balance Report", value: "indirect_expense_balance" },
    { label: "Expense Record", value: "expense_record" },
    { label: "Day Book", value: "daily_ledger" },
    { label: "Item Stock Report", value: "item_stock_in_report" },
    { label: "Profit Loss", value: "profit_loss" },
    { label: "Product Wise Profit/ Loss", value: "item_wise_profit_loss" },
    { label: "Bill Wise Profit/ Loss", value: "bill_wise_profit_loss" },
    { label: "Customer EMI Due List", value: "emi_due_list" },
    { label: "Loan Accounts Balance", value: "loan_balance" },
    { label: "Balance Sheet", value: "balance_sheet" },
    { label: "Trial Balance", value: "trial_balance" },
    {
      label: "Branch tarnsaction transfer list",
      value: "branch_tran_transfer_list",
    },
    { label: "Advance Customer Balance", value: "advance_debtor_balance" },
    { label: "Advance Supplier Balance", value: "advance_creditor_balance" },
    {
      label: "Indirect Income Accounts Balance",
      value: "indirect_income_balance",
    },
    { label: "Fixed Asset Accounts Balance", value: "fixed_asset_balance" },
    { label: "Capital Accounts Balance", value: "capital_balance" },
    { label: "Branch Balance Report", value: "branch_balance" },
    {
      label: "Indirect Expense Account Ledger",
      value: "indirect_expense_ledger",
    },
    { label: "Fixed Asset Account Ledger", value: "fixed_asset_ledger" },
    { label: "Loan Account Ledger", value: "loan_ledger" },
    {
      label: "Indirect Income Account Ledger",
      value: "indirect_income_ledger",
    },
    { label: "Capital Account Ledger", value: "capital_ledger" },
    { label: "Branch Ledger", value: "branch_ledger" },
    { label: "Sales Account Ledger", value: "sales_ledger" },
    { label: "Purchase Account Ledger", value: "purchase_ledger" },
    {
      label: "Service Expense Account Ledger",
      value: "service_expense_ledger",
    },
    { label: "Service Account Ledger", value: "service_ledger" },
    { label: "Sales Return Account Ledger", value: "sales_return_ledger" },
    {
      label: "Purchase Return Account Ledger",
      value: "purchase_return_ledger",
    },
    { label: "Tax Account Ledger", value: "tax_ledger" },
    { label: "Supplier Payment Record", value: "creditor_payment_record" },
    {
      label: "Expense Recognition Record",
      value: "expense_recognition_record",
    },
    { label: "Income Record", value: "income_record" },
    { label: "Journal Record", value: "journal_record" },
    { label: "Contra Record", value: "contra_record" },
    { label: "Sales Record", value: "sales_record_report" },
    { label: "Sales Return Record", value: "sales_return_record_report" },
    // { label: "Purchase Record", value: "purchase_record_report" },
    // { label: "Purchase Return Record", value: "purchase_return_record_report" },
    // { label: "Manufacturing Record", value: "production_record_report" },
    { label: "Direct Expense Balance", value: "direct_expense_balance" },
    { label: "Direct Expense Account Ledger", value: "direct_expense_ledger" },
    { label: "Direct Income Account Balance", value: "direct_income_balance" },
    { label: "Direct Income Account Ledger", value: "direct_income_ledger" },
    { label: "Salary Payment Report", value: "salary_in_report" },
    { label: "Monthly Salary Report", value: "monthly_salary_in_report" },
    {
      label: "Branch Transaction Inward",
      value: "branch_tran_transaction_inward",
    },
    {
      label: "Branch Transaction Outward",
      value: "branch_tran_transaction_outward",
    },
    {
      label: "Investment Balance",
      value: "investment_balance",
    },
    {
      label: "Investment Ledger",
      value: "investment_ledger",
    },
    {
      label: "Deposit Account Balance",
      value: "deposit_account_report",
    },
    {
      label: "Deposit Account Ledger",
      value: "deposit_account_ledger",
    },
    {
      label: "Current Liablity Report",
      value: "current_liability",
    },
    {
      label: "Current Liablity Ledger",
      value: "current_liability_ledger",
    },
    {
      label: "Current Asset Accounts Balance",
      value: "current_assets_balance",
    },
    {
      label: "Current Asset Accounts Ledger",
      value: "current_assets_ledger",
    },
    {
      label: "Suspense Balance",
      value: "suspense_balance",
    },
    {
      label: "Suspense Ledger",
      value: "suspense_ledger",
    },
    {
      label: "Reserve Surplus Balance",
      value: "reserve_surplus",
    },
    {
      label: "Reserve Surplus Ledger",
      value: "reserve_surplus_ledger",
    },
    {
      label: "Intangible Asset Ledger",
      value: "intangible_asset_ledger",
    },
    {
      label: "Intangible Asset",
      value: "intangible_asset",
    },
  ],
  crm: [
    { label: "Customers", value: "crm_customer_entry" },
    { label: "Crm Leads", value: "crm_leads" },
    { label: "Crm Deals", value: "crm_deals" },
    { label: "Crm Tasks", value: "crm_tasks" },
    { label: "Crm Customize", value: "crm_customize" },
    { label: "Pending Customers List", value: "pending_customer_list" },
    { label: "Approved Customers List", value: "approved_customer_list" },
    { label: "Rejected Customers List", value: "rejected_customer_list" },
    {
      label: "Employee Wise Customer Report",
      value: "employee_wise_customer_list",
    },
  ],
  ats: [
    { label: "Jobs", value: "ats_jobs" },
    { label: "Candidates", value: "ats_candidates" },
    { label: "Clients", value: "ats_clients" },
    { label: "Agencies", value: "ats_agencies" },
    { label: "Workflows", value: "ats_workflows" },
    { label: "Tasks", value: "ats_workflow_tasks" },
  ],
  delivery: [
    { label: "Dashboard", value: "delivery_jobs_manage" },
    { label: "Jobs", value: "delivery_jobs_manage" },
    { label: "Pickup", value: "delivery_jobs_manage" },
    { label: "Routes", value: "delivery_routes_manage" },
    { label: "Route Points", value: "delivery_routes_manage" },
    { label: "Areas", value: "delivery_routes_manage" },
    { label: "Assignments", value: "delivery_routes_manage" },
    { label: "Live Tracking", value: "delivery_routes_manage" },
    { label: "Status Flow", value: "delivery_routes_manage" },
    { label: "Delivery Users", value: "delivery_routes_manage" },
  ],
  settings: [
    { label: "Warehouse Entry", value: "warehouse_entry" },
    { label: "Branch Entry", value: "branch_entry" },
    { label: "SMS Sender", value: "sms_sender" },
    { label: "User Entry", value: "user_entry" },
    { label: "User Role Entry", value: "user_role_manage" },
    { label: "Company Profile", value: "company_profile" },
    { label: "Tag Entry", value: "tag_manage" },
    { label: "Subscription Entry", value: "subscription_info" },
  ],
};

const MenusList = [
  { label: "Dashboard", value: "dashboard" },
  { label: "Sales", value: "sales" },
  { label: "POS", value: "pos" },
  { label: "Quotation", value: "quotation" },
  { label: "Order", value: "order" },
  { label: "Service", value: "service" },
  { label: "Purchase", value: "purchase" },
  { label: "Manufacturing", value: "manufacturing" },
  { label: "Inventry", value: "inventry" },
  { label: "Accounts", value: "accounts" },
  { label: "HR&Payroll", value: "hrpayroll" },
  { label: "Reports", value: "reports" },
  { label: "CRM", value: "crm" },
  { label: "ATS", value: "ats" },
  { label: "Delivery", value: "delivery" },
  { label: "Settings", value: "settings" },
];

const accessTabs = (name) => {
  return accessList[name] || [];
};

const modifyAccessListBasedOnCompanyType = (authInfo) => {
  let updatedAccessList = accessList;
  const canUseWorkflows = hasWorkflowAccess(authInfo);

  if (!canUseWorkflows) {
    updatedAccessList = {
      ...updatedAccessList,
      ats: updatedAccessList.ats.filter(
        (item) =>
          item.value !== "ats_workflows" &&
          item.value !== "ats_workflow_tasks"
      ),
    };
  }

  if (
    authInfo?.branch_company_type == "Pharmacy" ||
    authInfo?.subscription == "SuperERP"
  ) {
    let updatedSales = [...updatedAccessList.sales];
    if (authInfo?.branch_company_type == "Pharmacy") {
      updatedSales = updatedAccessList.sales.filter(
        (item) => item.value !== "new_sales" && item.value !== "customer_entry"
      );
    }
    updatedSales.splice(
      0,
      0,
      { label: "Patient", value: "patient_overview" },
      { label: "Doctor", value: "doctor_overview" },
      { label: "New-Invoice", value: "pharma_sales" }
    );
    const updatedAccounts = [...updatedAccessList.accounts];
    updatedAccounts.splice(1, 0, {
      label: "Pharma Debitor Receipts",
      value: "pharma_debtor_receipts",
    });
    return {
      ...updatedAccessList,
      sales: updatedSales,
      accounts: updatedAccounts,
    };
  }
  return updatedAccessList;
};

let route_tab = [
  "admin-dashboard",
  "dashboard",
  "sales",
  "pos",
  "quotation",
  "order",
  "service",
  "purchase",
  "manufacturing",
  "inventory",
  "accounts",
  "hrpayroll",
  "reports",
  "crm",
  "settings",
];

const useIsAdminUser = () => {
  const authInfo = useSelector(selectAuthInfo);

  return isAdminUser(
    authInfo?.userInfo?.user_role_names
  );
};

export { modifyAccessListBasedOnCompanyType, route_tab, useIsAdminUser };
